"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var Example = function Example() {
  return _react.default.createElement("div", null, "Some stuff");
};

var _default = {
  route: 'you-wont-get-here',
  reducer: function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  },
  i18nSearchableKey: 'fsdaf',
  shouldModuleRender: function shouldModuleRender(_ref) {
    var scopes = _ref.scopes;
    return scopes.includes('madeup-scope-that-no-one-has');
  },
  routes: Example
};
exports.default = _default;
module.exports = exports.default;